/**
 * 繁体中文
 */
export default {
  route: {
    dashboard: {
      _name: '控制台',
      workplace: {_name: '工作臺'},
      analysis: {_name: '分析頁'},
      monitor: {_name: '監控頁'}
    },
    frontpage: {
      home: {_name: '首頁'},
      test: {_name: '接口調試'},
    },
    system: {
      _name: '賬號管理',
      admin: {_name: '管理列表'},
      finance: {_name: '資源列表'},
      user: {
        _name: '用戶列表',
        info: {_name: ''}
      },
      acceptor: {_name: '承兌列表'},
      menu: {_name: '菜單管理'},
      tenantAdmin: {_name: '運營列表'},
      tenant: {_name: '運營列表'},
    },
    resource: {
      _name: '資源管理',
      class: {_name: '資源分組'},
      recolumn: {_name: '收款資源'},
    },
    wallet: {
      _name: '錢包設置',
      walletlist: {_name: '錢包列表'},
      currency: {_name: '貨幣管理'},
      fiatcurrency: {_name: '法幣管理'},
      virtualcurrency: {_name: '虛擬幣管理'},
      transmodel: {_name: '交易模型'},
    },
    balance: {
      index: {_name: '用戶餘額'},
    },
    channel: {
      _name: '通道管理',
      type: {_name: '通道類型'},
      uplist: {_name: '渠道列表'},
      dscolumn: {_name: '通道列表(收)'},
      dfcolumn: {_name: '通道列表(付)'},
      amount: {_name: '預設設定'},
      records: {_name: '預設日誌'},
    },
    transaction: {
      _name: '交易管理',
      inorder: {_name: '收款訂單'},
      inlist: {_name: '收款確認'},
      outorder: {_name: '出款訂單'},
      records: {_name: '資金變動'},
      verifyorder: {_name: '核銷訂單'},
      errorlog: {_name: '商戶API錯誤'},
      upstreamerrorlog: {_name: '上游API錯誤'},
    },
    reconciliation: {
      _name: '對賬管理',
      bussiness: {_name: '用戶賬單'},
      uplist: {_name: '上游賬單'},
      channel: {_name: '通道賬單'},
      shouyi: {_name: '系統收益'},
      bank: {_name: '資源賬單'},
      bankrecords: {_name: '收款流水'},
    },
    config: {
      _name: '系統設置',
      dictionary: {_name: '字典管理'},
      website: {_name: '參數配置'},
      role: {_name: '角色管理'},
      errorlog: {_name: '系統維護'},
      countryregion: {_name: '國家地區'},
      banks: {_name: '銀行管理'},
      clientSimulator: {_name: '接口調試'},
      shuju: {_name: '數據清理'},
    },
    exception: {
      _name: '异常頁面',
      '403': {_name: '403'},
      '404': {_name: '404'},
      '500': {_name: '500'}
    },
    user: {
      _name: '個人設置',
      profile: {_name: '個人資料'},
      message: {_name: '我的消息'}
    },
  },
  layout: {
    home: '主頁',
    header: {
      profile: '個人中心',
      password: '修改密碼',
      logout: '安全登出'
    },
    footer: {
      website: '官網',
      document: '檔案',
      authorization: '授權',
      copyright: 'Copyright © 2021 南京RXThinkCMF研發中心'
    },
    logout: {
      title: '詢問',
      message: '確定要登出嗎?'
    }
  },
  login: {
    title: '海拉系統',
    username: '請輸入登入帳號',
    password: '請輸入登入密碼',
    captcha: '請輸入驗證碼',
    remember: '記住密碼',
    forget: '忘記密碼',
    login: '登入',
    loading: '登入中',
    ipChecking: '正在校驗訪問 IP…',
    ipDenied: '當前 IP 無訪問權限',
    ipCheckFailed: '無法完成 IP 校驗，請檢查網絡或聯繫管理員',
    googleAuthenticator: 'Google Authenticator(若綁定)',
  },





    // 通用
    universal:{
      startingtime:"開始時間",
      endtime:"結束時間",
      pleasechoose:"請選擇",
      pleaseenter:"請輸入",
      recognize: "確認",
      inquire:"查詢",
      reset:"重置",
      export:"導出",
      turnon:"開啓",
      closure:"關閉",
      yes:"是",
      no:"否",
      unknown: '未知',
      success: '成功',
      retreat: '撤銷',
      abnormal: '異常',
      cancel: '取消',
    },
    // 首页
    home:{
      totalbalance:"總餘額",
      availablebalance:"可用餘額",
      freezebalance:"凍結金額",
      unsettledamount:"未結算餘額",
    },
    // 清理数据
    cleandata:{
      selecttime:"選擇時間",
      startingtime:"開始時間",
      endtime:"結束時間",
      selectdata:"選擇數據",
      choose:"請選擇",
      option1:"[ 全部數據 ] | 謹慎選擇，刪除后無法恢復!!!",
      option2:"[ 收款數據 ] | 謹慎選擇，刪除后無法恢復!!!",
      option3:"[ 出款數據 ] | 謹慎選擇，刪除后無法恢復!!!",
      option4:"[ 賬變數據 ] | 謹慎選擇，刪除后無法恢復!!!",
      warnings: "提示：請謹慎刪除，操作后無法恢復！",
      recognize: "確認清理",
      confirmTitle: "提示",
      confirmDelete: "確認刪除",
    },
    maintenance: {
      errorLog: '錯誤日誌',
      paymentLog: '調試日誌',
      dataClean: '數據清理',
      logTime: '時間',
      logFile: '日誌文件',
      logContent: '日誌內容',
      clearLog: '清理錯誤日誌',
      clearPaymentLog: '清理調試日誌',
      clearLogConfirm: '確定要清理所有錯誤日誌嗎？清理后無法恢復！',
      clearPaymentLogConfirm: '確定要清理所有調試日誌嗎？清理后無法恢復！',
    },
    // 订单列表
    orderlist:{
      username:"用戶名稱",
      userorder:"用戶訂單",
      systemorder:"系統訂單",
      transactiontype:"交易類型",
      channelorder:"通道訂單",
      tradingstatus:"交易狀態",
      transactionaccountchanges:"交易賬變",
      selectionperiod:"選擇時間",
    },
    // 头部统计
    statistics:{
      today_success:"[今日成功]:",
      today_receipt:"[今日收款]:",
      unknown_orders:" [未知訂單]:",
      unknown_amount:" [未知金額]:",
      service_fee:" [交易手續費]:",
      order_rate:" [訂單費率]:",
    }
}
